import { useHistory } from 'react-router-dom';
import { type CustomerAddress } from '@hungryroot/pages-checkout';
import { Heading, Paragraph } from '@hungryroot/ramen';
import {
  PATHS,
  SHIPPING_PATH,
} from '../../../../frontend/react/src/constants/checkout';
import styles from './AddressSummary.module.css';

interface Props {
  testid?: string;
  address: CustomerAddress;
  deliveryDate: string;
}

export function AddressSummary(props: Props) {
  const { testid, address, deliveryDate } = props;
  const history = useHistory();

  const addressText = `${address.street}, ${address.city}, ${address.state} ${address.zipcode}`;

  return (
    <div data-testid={testid} className={styles.container}>
      <div className={styles.heading}>
        <Heading variant="H5">Delivery address</Heading>
        <button
          className={styles.edit}
          onClick={() => history.push(PATHS[SHIPPING_PATH])}
        >
          <Heading variant="H6">Edit</Heading>
        </button>
      </div>
      <div className={styles['address-container']}>
        <Paragraph className={styles['user-info']}>{address.name}</Paragraph>
        <Paragraph className={styles['user-info']}>{addressText}</Paragraph>
      </div>
      <Heading variant="H5" className={styles.heading}>
        First delivery date
      </Heading>
      <Paragraph className={styles['user-info']}>{deliveryDate}</Paragraph>
    </div>
  );
}
